import { useEffect, useState, useMemo } from "react";
import { api } from "../lib/api";
import FacultyDrilldown from "../components/FacultyDrilldown";

const color = (score) => score >= 90 ? 'var(--ok)' : score >= 70 ? 'var(--warn)' : 'var(--bad)';

export default function Compliance() {
  const [rows, setRows] = useState([]);
  const [drill, setDrill] = useState(null);

  useEffect(() => {
    let alive = true;
    api.get("/stats/compliance")
      .then(({data}) => { if (alive) setRows(data); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  const overall = useMemo(() => {
    if (!rows.length) return 0;
    return Math.round(rows.reduce((a,r) => a + r.score, 0) / rows.length);
  }, [rows]);

  return (
    <div data-testid="view-compliance">
      <div className="topbar">
        <div>
          <h1 className="pg-title">NMC Compliance Audit</h1>
          <div className="pg-sub">Per-department compliance score with specific gaps flagged · Gazette of 14 Feb 2022 · click department to drill down</div>
        </div>
        <div className="topbar-meta"><span className="meta-chip">Overall · {overall}%</span></div>
      </div>

      <div className="card">
        <div className="card-title">Compliance by Department</div>
        {rows.map(r => (
          <div className="comp-dept" key={r.department} style={{cursor:'pointer'}}
            onClick={() => setDrill({ department: r.department, title: r.department })}
            data-testid={`comp-dept-${r.department}`}>
            <div className="comp-head">
              <span className="comp-name" style={{textDecoration:'underline',textDecorationStyle:'dotted',textUnderlineOffset:3}}>{r.department}</span>
              <span className="comp-score" style={{color: color(r.score)}}>{r.score}%</span>
            </div>
            <div className="comp-bar"><span style={{width:`${r.score}%`, background: color(r.score)}}/></div>
            <div className="comp-gaps" style={r.gaps.length === 0 ? {color:'var(--ok)'} : null}>
              {r.gaps.length === 0 ? 'All criteria met' : <>Gaps: {r.gaps.join(' · ')}</>}
            </div>
          </div>
        ))}
      </div>

      {drill && <FacultyDrilldown department={drill.department} designation={drill.designation} title={drill.title} onClose={() => setDrill(null)}/>}
    </div>
  );
}
